@if (type === 'list') {
<div class="skeleton-wrapper">
  <!-- Top header button placeholder -->
  @if (showButton) {
  <div class="d-flex justify-content-end mb-2 pe-2 mt-2">
    <div class="shimmer skeleton-btn"></div>
  </div>
  }

  <!-- Search and Pills Row placeholder -->
  @if (showSearch) {
  <div class="d-flex justify-content-between align-items-center mb-3 mt-3 ps-3 pe-3">
    <!-- Search Bar Skeleton -->
    <div class="shimmer skeleton-search"></div>
    
    <!-- Pills Skeletons -->
    <div class="d-flex gap-2">
      @for (p of getFakeArray(pillsCount); track $index) {
      <div class="shimmer skeleton-pill"></div>
      }
    </div>
  </div>
  }

  <!-- Table Body Placeholder -->
  <div class="table-skeleton-container ps-3 pe-3">
    <!-- Header Row -->
    <div class="skeleton-table-header d-flex align-items-center py-3 border-bottom">
      <div class="shimmer col-1 skeleton-checkbox"></div>
      @for (c of getFakeArray(colsCount - 1); track $index) {
      <div class="shimmer col skeleton-header-cell ms-3"></div>
      }
    </div>

    <!-- Data Rows -->
    @for (r of getFakeArray(rowsCount); track $index) {
    <div class="skeleton-table-row d-flex align-items-center py-3 border-bottom">
      <!-- Checkbox column -->
      <div class="shimmer col-1 skeleton-checkbox"></div>
      
      <!-- Thumbnail / Icon column -->
      <div class="shimmer skeleton-thumb ms-3"></div>

      <!-- Other text columns -->
      @for (c of getFakeArray(colsCount - 2); track $index) {
      <div class="shimmer col skeleton-cell ms-3"></div>
      }
    </div>
    }
  </div>
</div>
}

@if (type === 'media-tile') {
<div class="skeleton-wrapper">
  @if (showButton) {
  <div class="d-flex justify-content-end mb-2 pe-2 mt-2">
    <div class="shimmer skeleton-btn"></div>
  </div>
  }

  @if (showSearch) {
  <div class="d-flex justify-content-between align-items-center mb-3 mt-3 ps-3 pe-3">
    <div class="shimmer skeleton-search"></div>
    <div class="d-flex align-items-center gap-2">
      <div class="shimmer skeleton-view-toggle"></div>
      @for (p of getFakeArray(pillsCount); track $index) {
      <div class="shimmer skeleton-pill"></div>
      }
    </div>
  </div>
  }

  <div class="tile-skeleton-container ps-3 pe-3">
    <div class="tile-skeleton-grid">
      @for (r of getFakeArray(rowsCount); track $index) {
      <div class="tile-skeleton-card">
        <div class="shimmer tile-skeleton-checkbox"></div>
        <div class="shimmer tile-skeleton-thumb"></div>
        <div class="tile-skeleton-info">
          <div class="shimmer tile-skeleton-title"></div>
          <div class="d-flex align-items-center justify-content-between mt-2">
            <div class="shimmer tile-skeleton-meta"></div>
            <div class="shimmer tile-skeleton-badge"></div>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</div>
}

@if (type === 'composition-detail') {
<div class="skeleton-wrapper px-3 pt-2">
  <!-- Breadcrumb and Top Buttons Row -->
  <div class="d-flex justify-content-between align-items-center mb-3">
    <div class="shimmer skeleton-breadcrumb"></div>
    <div class="d-flex gap-2">
      <div class="shimmer skeleton-btn-sm"></div>
      <div class="shimmer skeleton-btn-sm"></div>
      <div class="shimmer skeleton-btn-sm"></div>
    </div>
  </div>

  <!-- Three Pane Layout Workspace Mockup -->
  <div class="workspace-shimmer">
    <!-- LEFT PANEL: Media Library -->
    <div class="panel-left border rounded p-3 bg-white">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div class="shimmer header-line"></div>
        <div class="shimmer upload-btn-placeholder"></div>
      </div>
      <div class="shimmer search-bar-placeholder mb-3"></div>
      <div class="d-flex gap-1 mb-3">
        @for (i of getFakeArray(4); track $index) {
        <div class="shimmer media-tag-placeholder"></div>
        }
      </div>
      <div class="media-rows">
        @for (r of getFakeArray(5); track $index) {
        <div class="d-flex align-items-center mb-3 py-2 border-bottom">
          <div class="shimmer media-row-thumb"></div>
          <div class="ms-2 flex-grow-1">
            <div class="shimmer media-row-title mb-2"></div>
            <div class="shimmer media-row-meta"></div>
          </div>
        </div>
        }
      </div>
    </div>

    <!-- CENTER PANEL: Canvas Work area and playlist timeline -->
    <div class="panel-center">
      <!-- Upper Section: Canvas Layout zones preview -->
      <div class="canvas-preview border rounded p-3 bg-white mb-3">
        <div class="shimmer canvas-box w-100"></div>
      </div>
      <!-- Lower Section: Timeline Tracks list -->
      <div class="timeline-list-placeholder border rounded p-3 bg-white">
        <div class="d-flex align-items-center mb-3 py-2 border-bottom">
          <div class="shimmer col-1 skeleton-checkbox"></div>
          <div class="shimmer col-1 skeleton-thumb ms-3"></div>
          <div class="shimmer col-6 skeleton-header-cell ms-3"></div>
        </div>
        @for (r of getFakeArray(4); track $index) {
        <div class="d-flex align-items-center py-3 border-bottom">
          <div class="shimmer col-1 skeleton-checkbox"></div>
          <div class="shimmer col-1 skeleton-thumb ms-3"></div>
          <div class="shimmer col-4 skeleton-header-cell ms-3"></div>
          <div class="shimmer col-2 skeleton-header-cell ms-auto"></div>
        </div>
        }
      </div>
    </div>

    <!-- RIGHT PANEL: Properties details panel -->
    <div class="panel-right border rounded p-3 bg-white">
      <div class="shimmer header-line mb-4"></div>
      @for (i of getFakeArray(6); track $index) {
      <div class="mb-4">
        <div class="shimmer prop-label mb-2"></div>
        <div class="shimmer prop-value w-100"></div>
      </div>
      }
    </div>
  </div>
</div>
}

@if (type === 'screen-detail') {
<div class="skeleton-wrapper px-3 pt-2">
  <!-- Breadcrumb and Actions Row -->
  <div class="d-flex justify-content-between align-items-center mb-3">
    <div class="shimmer skeleton-breadcrumb"></div>
    <div class="d-flex gap-2">
      <div class="shimmer skeleton-btn-sm"></div>
      <div class="shimmer skeleton-btn-sm"></div>
      <div class="shimmer skeleton-btn-sm"></div>
      <div class="shimmer skeleton-btn-sm"></div>
    </div>
  </div>

  <!-- Screen Details Grid Content -->
  <div class="screen-detail-grid">
    <!-- LEFT CARD: Screen orientation, status info -->
    <div class="screen-info-card border rounded p-3 bg-white">
      <div class="shimmer screen-card-img w-100 mb-3"></div>
      <div class="shimmer screen-card-title mb-2"></div>
      <div class="shimmer screen-card-subtitle mb-4"></div>
      <hr class="mb-4 border-light" />
      @for (i of getFakeArray(4); track $index) {
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div class="shimmer prop-label"></div>
        <div class="shimmer prop-value w-50"></div>
      </div>
      }
    </div>

    <!-- RIGHT CARD: Active schedules, tabs info -->
    <div class="screen-schedule-card border rounded p-3 bg-white">
      <!-- Tabs Header -->
      <div class="d-flex gap-3 mb-4 border-bottom pb-2">
        <div class="shimmer tab-btn"></div>
        <div class="shimmer tab-btn"></div>
        <div class="shimmer tab-btn"></div>
      </div>
      <!-- Tab Contents (Active Schedules list) -->
      <div class="schedule-table-placeholder">
        <div class="d-flex align-items-center py-2 border-bottom mb-3">
          <div class="shimmer col-2 skeleton-header-cell"></div>
          <div class="shimmer col-4 skeleton-header-cell ms-3"></div>
          <div class="shimmer col-2 skeleton-header-cell ms-3"></div>
          <div class="shimmer col-2 skeleton-header-cell ms-3"></div>
        </div>
        @for (r of getFakeArray(4); track $index) {
        <div class="d-flex align-items-center py-3 border-bottom">
          <div class="shimmer col-2 skeleton-cell"></div>
          <div class="shimmer col-4 skeleton-cell ms-3"></div>
          <div class="shimmer col-2 skeleton-cell ms-3"></div>
          <div class="shimmer col-2 skeleton-cell ms-3"></div>
        </div>
        }
      </div>
    </div>
  </div>
</div>
}
